const TOKEN_KEY = "access_token";

// Get the token from local storage
export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

// Set the token in local storage
export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

// Remove the token from local storage
export function removeToken() {
  localStorage.removeItem(TOKEN_KEY);
}
